import { useState } from "react";

export default function Input({
  label,
  labelSuffix,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  margin = "mb-4",
  required = false,
  children,
  icon: Icon,
  onFocus,
  onBlur,
  onClick,
  ...rest
}) {
  const [isFocused, setIsFocused] = useState(false);
  const isRTL = document.documentElement.dir === "rtl";
  
  const inputClasses =
    `w-full h-10 rounded-lg focus:outline-none text-[13px] text-[var(--color-text-primary)] ${isRTL ? "text-right" : "text-left"} ${Icon ? (isRTL ? "pr-10 pl-4" : "pl-10 pr-4") : "px-4"}` +
    ` bg-[var(--color-bg-card)] border-2 border-[var(--color-border)]` +
    ` transition-[border-color,box-shadow] duration-300` +
    ` focus:border-[var(--color-primary)] focus:shadow-[0_0_14px_var(--color-shadow-primary),inset_0_0_8px_var(--color-primary-50)]` +
    ` placeholder-[var(--color-text-muted)] placeholder:text-[13px]`;

  return (
    <div className={margin}>
      {label && (
        <label
          className={`block text-sm font-medium mb-2 text-(--color-text-secondary) ${isRTL ? "text-right" : "text-left"}`}
        >
          {label}
          {labelSuffix && (
            <span
              className={`${isRTL ? "mr-1" : "ml-1"} text-xs font-normal text-(--color-text-muted)`}
            >
              {labelSuffix}
            </span>
          )}
          {required && <span className="required-asterisk" />}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div
            data-focused={isFocused}
            className={`qv-input-icon absolute ${isRTL ? "right-4" : "left-4"} top-1/2 pointer-events-none`}
          >
            <Icon className={`w-5 h-5 transition-colors duration-300 ${isFocused ? "text-(--color-primary)" : "text-(--color-text-muted)"}`} />
          </div>
        )}
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          dir={isRTL ? "rtl" : "ltr"}
          required={required}
          onFocus={(e) => {
            setIsFocused(true);
            if (onFocus) onFocus(e);
          }}
          onBlur={(e) => {
            setIsFocused(false);
            if (onBlur) onBlur(e);
          }}
          onClick={onClick}
          {...rest}
          className={inputClasses}
        />
        {children}
      </div>
    </div>
  );
}
